import {Result} from "antd";
import {RoutingPaths} from "../../routing/routingContainer";
import {useState} from "react";
import {useNavigate} from "react-router-dom";
import {AsyncButton} from "digimuth-components/dist";
import {useAuth} from "oidc-react";
import AuthenticationLayout from "../authenticationLayout";
import ActivateContainer from "./acticateContainer";

export default function ActivatePage() {

    const [submitted, setSubmitted] = useState<boolean>(false);

    return <AuthenticationLayout title={submitted ? undefined : "Dokończ rejestrację"}>
        {submitted
            ? <ActivateSuccessResult/>
            : <ActivateFormContainer onAfterSubmit={() => setSubmitted(true)}/>}
    </AuthenticationLayout>;
}

function ActivateFormContainer(props: { onAfterSubmit: () => void }) {
    return <ActivateContainer onAfterSubmit={props.onAfterSubmit}/>;
}

function ActivateSuccessResult() {
    const navigate = useNavigate();
    const auth = useAuth();

    return <Result
        title="Pomyślnie ustawiono nowe hasło. Możesz teraz rozpocząć korzystanie z serwisu"
        status="success"
        extra={
            <AsyncButton type="default" onClick={async () => {
                await auth.userManager.signinSilent();
                navigate(RoutingPaths.confirmDetails.route, {replace: true});
            }}>
                Zaloguj się
            </AsyncButton>
        }
    />;
}
